import { render } from "./NavBarItem.vue?vue&type=template&id=3777e3e8&scoped=true&ts=true"
import script from "./NavBarItem.vue?vue&type=script&lang=ts"
export * from "./NavBarItem.vue?vue&type=script&lang=ts"

import "./NavBarItem.vue?vue&type=style&index=0&id=3777e3e8&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3777e3e8"]])

export default __exports__